import defaultTheme from './themedefault';
import clone from 'clone';

const theme = clone(defaultTheme);
theme.palette.primary = ['#B08C3D'];
theme.palette.secondary = ['#B08C3D'];
export default theme;
